import { Skeleton } from '@/components/ui/skeleton';
import { useIsMobile } from '@/hooks/useMobile';

/**
 * Folder loading skeleton (main content only).
 * Member chat is mounted at layout level and keeps its own state while folders load.
 */
function FolderByIdSkeleton({ folderId: _folderId }: { folderId?: string | number }) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className="flex h-full min-h-0 w-full flex-col overflow-hidden">
        <div className="min-h-0 flex-1 overflow-hidden px-3 py-3">
          <div className="space-y-3">
            <Skeleton className="h-14 w-full rounded-lg" />
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton key={index} className="h-10 w-full rounded-md" />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-0 w-full flex-col overflow-hidden">
      <div className="min-h-0 mt-2 flex-1 overflow-hidden px-3 py-3">
        <div className="container mx-auto max-w-4xl space-y-4">
          <Skeleton className="h-10 w-full rounded-sm" />
          <Skeleton className="h-10 w-full rounded-sm" />
          <Skeleton className="h-10 w-full rounded-sm" />
        </div>
      </div>
    </div>
  );
}

export default FolderByIdSkeleton;
